module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Logo")]), _vm._v(" "), (_vm.config) ? _c('v-flex', {
    style: ({
      width: _vm.logo_width + 'px'
    })
  }, [_c('v-card', [_c('v-img', {
    attrs: {
      "src": _vm.logo,
      "height": (_vm.logo_width / _vm.logo_ratio) + 'px'
    }
  }), _vm._v(" "), _c('v-card-title', [_vm._v("Logo (120x32) (ratio: 3,75)")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.show_logo_upload = !_vm.show_logo_upload
      }
    }
  }, [_vm._v("\n          upload\n          "), _c('v-icon', [_vm._v(_vm._s(_vm.show_logo_upload ? 'keyboard_arrow_down' : 'keyboard_arrow_up'))])], 1)], 1), _vm._v(" "), _c('v-slide-y-transition', [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_logo_upload),
      expression: "show_logo_upload"
    }]
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.uploadLogo($event.target.files[0])
      }
    }
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Hero Image")]), _vm._v(" "), (_vm.config) ? _c('v-flex', {
    style: ({
      width: _vm.hero_width + 'px'
    })
  }, [_c('v-card', [_c('v-img', {
    attrs: {
      "src": _vm.hero,
      "height": (_vm.hero_width / _vm.hero_ratio) + 'px'
    }
  }), _vm._v(" "), _c('v-card-title', [_vm._v("Logo (1600 x 1067) (ratio: 1,5)")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.show_hero_upload = !_vm.show_hero_upload
      }
    }
  }, [_vm._v("\n          upload\n          "), _c('v-icon', [_vm._v(_vm._s(_vm.show_hero_upload ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1), _vm._v(" "), _c('v-slide-y-transition', [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_hero_upload),
      expression: "show_hero_upload"
    }]
  }, [(_vm.hero_upload_in_progress) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.uploadHero($event.target.files[0])
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Color Configuration")]), _vm._v(" "), _c('isrs-settings-dialog', {
    attrs: {
      "fields": _vm.fields,
      "input-form-fields-activated": _vm.configActivated,
      "input-form-data": _vm.config
    },
    on: {
      "formDataChanged": function (config) { return _vm.saveConfig(config); }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-8c78d7da"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/Appearance.vue
// module id = 946
// module chunks = 1